'use strict';

import { Component } from 'react';
import { connectScrollTo } from 'react-instantsearch-dom';

class ScrollTo extends Component {
	componentDidUpdate(prevProps) {
		const { value, hasNotChanged } = this.props;
		if (value !== prevProps.value && hasNotChanged) {
			window.scrollTo(0, 0);
		}
	}
	
	render() {
		return <div>{ this.props.children }</div>;
	}
}

export default connectScrollTo(ScrollTo);
